/**
 * Gera uma cor consistente baseada em um ID numérico
 * @param {number} id - ID para gerar a cor
 * @returns {string} Cor em formato hexadecimal
 */
export function generateColorFromId(id) {
  if (!id || id === null) {
    return '#6c757d'; // Cor padrão cinza para null
  }
  
  // Usa o ID para gerar valores de HSL consistentes
  const hue = (id * 137.508) % 360; // 137.508 é um ângulo de ouro que distribui bem as cores
  const saturation = 60 + (id % 20); // Saturação entre 60-80%
  const lightness = 45 + (id % 15); // Luminosidade entre 45-60%
  
  return hslToHex(hue, saturation, lightness);
}

/**
 * Converte HSL para hexadecimal
 */
function hslToHex(h, s, l) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

/**
 * Gera uma cor de texto legível (branco ou preto) baseada no background
 * @param {string} backgroundColor - Cor de fundo em hexadecimal
 * @returns {string} 'white' ou 'black'
 */
export function getContrastTextColor(backgroundColor) {
  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? 'black' : 'white';
}

